var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3648 6.03204C7.39432 6.14101 7.4932 6.21668 7.6061 6.21668H9.74398C9.90939 6.21668 10.0295 6.05969 9.98531 5.90027C9.65923 4.72174 9.15214 2.85607 8.99231 2.26751C8.96273 2.15859 8.86398 2.08334 8.75108 2.08334H6.87648C6.78028 2.08334 6.68743 2.09007 6.59592 2.09956C6.44433 2.11529 6.3447 2.26605 6.38454 2.41315L7.3648 6.03204Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9605 2.26747C12.9309 2.15857 12.8322 2.08334 12.7193 2.08334H10.5489C10.3834 2.08334 10.2636 2.2411 10.308 2.40044L11.3204 6.03378C11.3505 6.14189 11.4489 6.21668 11.5612 6.21668H13.7129C13.8784 6.21668 13.9984 6.05964 13.9543 5.90022C13.6277 4.72084 13.1204 2.85584 12.9605 2.26747Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2888 6.03363C15.3189 6.14175 15.4174 6.21654 15.5296 6.21654H17.8784C18.0176 6.21654 18.1306 6.10249 18.1228 5.96347C17.9983 3.76953 16.5993 2.27525 14.5236 2.10486C14.3574 2.09121 14.2346 2.24993 14.2793 2.41063L15.2888 6.03363Z",
    fill: "#969696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79248 6.21602C5.95715 6.21602 6.07684 6.05958 6.03378 5.90063L5.17771 2.74118C5.13743 2.59253 4.97316 2.51483 4.83826 2.58913C3.69065 3.22122 2.96559 4.41586 2.87783 5.96295C2.86995 6.10193 2.98295 6.21602 3.12216 6.21602H5.79248Z",
    fill: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97089 10.2363C9.89089 10.2038 9.81422 10.1863 9.74506 10.1863C9.68422 10.1863 9.62922 10.1997 9.58589 10.2247C9.50506 10.2713 9.45506 10.363 9.43756 10.4972C9.33922 11.3763 9.33922 12.318 9.43922 13.2847C9.44839 13.3513 9.48006 13.4947 9.58256 13.5547C9.67089 13.6063 9.81256 13.5997 9.97339 13.5355C10.7009 13.2447 11.3942 12.8105 11.9784 12.2788C12.0742 12.1913 12.1884 12.0522 12.1876 11.8855C12.1876 11.718 12.0742 11.5813 11.9801 11.4963C11.3984 10.9655 10.7234 10.5422 9.97089 10.2363Z",
    fill: "#969696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8191 13.2033C12.1249 13.8342 11.3024 14.35 10.4382 14.6958C10.1974 14.7925 9.95742 14.8408 9.72658 14.8408C9.44825 14.8408 9.18325 14.7708 8.94742 14.6317C8.53078 14.3858 8.26412 13.9575 8.19745 13.4267C8.08662 12.3575 8.08745 11.3258 8.19662 10.3467C8.26745 9.80917 8.53828 9.38584 8.96158 9.14167C9.39742 8.89084 9.93825 8.87 10.4466 9.08084C11.3316 9.44 12.1316 9.9425 12.8199 10.5708C13.2157 10.9283 13.4366 11.3942 13.4374 11.8817C13.4391 12.37 13.2191 12.8392 12.8191 13.2033ZM3.11328 7.46582C2.97521 7.46582 2.86328 7.57775 2.86328 7.71582V13.7158C2.86328 16.2283 4.47661 17.9158 6.87662 17.9158H14.1224C16.5241 17.9158 18.1366 16.2283 18.1366 13.7158V7.71582C18.1366 7.57775 18.0247 7.46582 17.8866 7.46582H3.11328Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReels);
export default __webpack_public_path__ + "static/media/Reels.114a1e7fbe6c10736f0be9cf59d6ea80.svg";
export { ForwardRef as ReactComponent };